import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchChatList } from "services/api/chat";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { ChatListResponse, ChatListSlice } from "types/chat";
import { generateUniqueKey, isFresh } from "utils/helpers";

export const fetchChatListThunk = createAsyncThunk<{chats: ChatListResponse, filters: {page: number, [key: string]: any}, filterId: string}, {force?: boolean, filters: {page: number, [key: string]: any}}, {rejectValue: string}>(
    'user/chats',
    async ({force, filters}, { getState, rejectWithValue }) => {
        try {
            const STALE_TIME = apiConfig.FETCH_CHATS_LIST.staleTime;
            const filterId = generateUniqueKey(filters, ['page']);
            const state = getState() as {auth: AuthState, chatList: ChatListSlice};
            if(filters.page === 1 && !force && isFresh(state.chatList.filtered_lists?.[filterId]?.last_fetched_at ?? null, STALE_TIME)){
                return rejectWithValue(ERROR.CACHED);
            }
            const agencyId = state.auth.selectedAgency?.uuid ?? '';
            const chats = await fetchChatList(filters);
            return {chats, filters, filterId};
        } catch (error) {
            return rejectWithValue('Failed to fetch chats');
        }
    }
)